import { type CSSProperties, useEffect, useState } from "react";
import { LANDING_NAV_HEIGHT_PX } from "./layout";

/**
 * Measures the host page's own navbar so pinned stages and scroll padding track the
 * real header height. In Webflow the site nav renders with the `.w-nav` class (72px
 * today, not the 94px Figma header); the local preview has no `.w-nav` and falls back
 * to LANDING_NAV_HEIGHT_PX, which the dev topbar matches.
 */
export function useHostNavHeight(): number {
	const [navHeight, setNavHeight] = useState(LANDING_NAV_HEIGHT_PX);

	useEffect(() => {
		const measure = () => {
			const measured = document.querySelector(".w-nav")?.getBoundingClientRect().height ?? 0;
			setNavHeight(measured > 0 ? Math.round(measured) : LANDING_NAV_HEIGHT_PX);
		};
		measure();
		window.addEventListener("resize", measure);
		return () => window.removeEventListener("resize", measure);
	}, []);

	return navHeight;
}

export function hostNavHeightStyle(navHeight: number): CSSProperties {
	return { "--landing-nav-height": `${navHeight}px` } as CSSProperties;
}
